import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { removeProgressBar } from 'services/store/features/progressBar/actions';
import UploadProgressionBar from './UploadProgressionBar';
var mapStateToProps = function (state) { return ({
    list: state.progress.list,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    actions: bindActionCreators({ removeProgressBar: removeProgressBar }, dispatch),
}); };
export default connect(mapStateToProps, mapDispatchToProps)(UploadProgressionBar);
